import { render } from "./exchangeNaive.vue?vue&type=template&id=28273a3c&scoped=true&lang=pug"
import script from "./exchangeNaive.vue?vue&type=script&setup=true&lang=js"
export * from "./exchangeNaive.vue?vue&type=script&setup=true&lang=js"

import "./exchangeNaive.vue?vue&type=style&index=0&id=28273a3c&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28273a3c"]])

export default __exports__